import { create } from "zustand";

type ClaimFormData = {
  userId: string | null;
  policyInfo: Record<string, any> | null;
  claimant: Record<string, any> | null;
  deceased: Record<string, any> | null;
  selectedLivesInsured: Record<string, any> | null;
  claimBenefit: Record<string, any> | null;
  product: Record<string, any> | null;
  supplementary: Array<Record<string, any>>;
  isPolicyUnderWaitingPeriod: boolean | null;
  isClaimSubmissionWindowExpired: boolean | null;
  bankingInfo: Record<string, any> | null;
  documents: Record<string, File>;
  typeOfClaim: any;
  setUserId: (id: string) => void;
  setPolicyInfo: (data: Record<string, any>) => void;
  setClaimant: (data: Record<string, any>) => void;
  setDeceased: (data: Record<string, any>) => void;
  setSelectedLivesInsured: (data: Record<string, any> | null) => void;
  setClaimBenefit: (data: Record<string, any>) => void;
  setProduct: (data: Record<string, any>) => void;
  setSupplementary: (data: Array<Record<string, any>>) => void;
  setIsPolicyUnderWaitingPeriod: (data: boolean) => void;
  setIsClaimSubmissionWindowExpired: (data: boolean) => void;
  setBankingInfo: (data: Record<string, any>) => void;
  addDocument: (key: any, file: File) => void;
  removeDocument: (key: string) => void;
  clearDocuments: () => void;
  setTypeOfClaim: (data: any) => void;
  getFullPayload: () => Record<string, any>;
  reset: () => void;
};

export const useClaimFormStore = create<ClaimFormData>((set, get) => ({
  userId: null,
  policyInfo: null,
  claimant: null,
  deceased: null,
  selectedLivesInsured: null,
  claimBenefit: null,
  product: null,
  supplementary: [],
  isPolicyUnderWaitingPeriod: null,
  isClaimSubmissionWindowExpired: null,
  bankingInfo: null,
  typeOfClaim: null,
  documents: {},

  setUserId: (id) => set({ userId: id }),
  setClaimant: (data) => set({ claimant: data }),
  setDeceased: (data) => set({ deceased: data }),
  setSelectedLivesInsured: (data) => set({ selectedLivesInsured: data }),
  setClaimBenefit: (data) => set({ claimBenefit: data }),
  setProduct: (data) => set({ product: data }),
  setSupplementary: (data) => set({ supplementary: data }),
  setIsPolicyUnderWaitingPeriod: (data) =>
    set({ isPolicyUnderWaitingPeriod: data }),
  setIsClaimSubmissionWindowExpired: (data) =>
    set({ isClaimSubmissionWindowExpired: data }),
  setBankingInfo: (data) => set({ bankingInfo: data }),
  setTypeOfClaim: (data) => set({ typeOfClaim: data }),
  addDocument: (key: string, file: File) =>
    set((state) => ({
      documents: { ...state.documents, [key]: file },
    })),
  removeDocument: (key) =>
    set((state) => {
      const newDocs = { ...state.documents };
      delete newDocs[key];
      return { documents: newDocs };
    }),
  clearDocuments: () => set({ documents: {} }),
  setPolicyInfo: (data) => set({ policyInfo: data }),

  getFullPayload: () => {
    const {
      userId,
      policyInfo,
      claimant,
      deceased,
      selectedLivesInsured,
      claimBenefit,
      typeOfClaim,
      bankingInfo,
      product,
      supplementary,
      isPolicyUnderWaitingPeriod,
      isClaimSubmissionWindowExpired,
    } = get();

    const payload: Record<string, any> = {
      policyInfo,
      claimant,
      deceased,
      selectedLivesInsured,
      typeOfClaim,
      claimBenefit,
      bankingInfo,
      product,
      supplementary,
      isPolicyUnderWaitingPeriod,
      isClaimSubmissionWindowExpired,
    };

    if (userId) {
      payload.userId = userId;
    }

    return payload;
  },
  reset: () =>
    set({
      userId: null,
      policyInfo: null,
      claimant: null,
      deceased: null,
      selectedLivesInsured: null,
      claimBenefit: null,
      product: null,
      supplementary: [],
      isPolicyUnderWaitingPeriod: null,
      isClaimSubmissionWindowExpired: null,
      bankingInfo: null,
      typeOfClaim: null,
      documents: {},
    }),
}));
